module.exports = __webpack_public_path__ + "img/icon_media.286588f.svg";